import { useEffect } from 'react';

const FONT_LINKS = {
  boda: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600&family=Playfair+Display:wght@400;700;900&display=swap',
  cumple: 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@500;700;800&family=Fredoka:wght@400;500;600&display=swap',
  baby: 'https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap',
  bautizo: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&display=swap',
  gradu: 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Inter:wght@400;500;600&display=swap',
};

export default function Fonts({ for: kind }) {
  useEffect(() => {
    const link = FONT_LINKS[kind] || FONT_LINKS.boda;
    const id = `gf-font-${kind}`;
    if (document.getElementById(id)) return;
    const el = document.createElement('link');
    el.id = id;
    el.rel = 'stylesheet';
    el.href = link;
    document.head.appendChild(el);
  }, [kind]);

  return null;
}